define(["dojo/i18n", "/home/semaphore/scramble4/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"scramble/widgets/dashboard/nls/zh-tw/orderStatusGrid"
,"scramble/widgets/dashboard/nls/zh/orderStatusGrid"
,"scramble/widgets/dashboard/nls/ja/orderStatusGrid"
,"scramble/widgets/dashboard/nls/fr/orderStatusGrid"
,"scramble/widgets/dashboard/nls/de/orderStatusGrid"
,"scramble/widgets/dashboard/nls/ko/orderStatusGrid"
,"scramble/widgets/dashboard/nls/it/orderStatusGrid"
,"scramble/widgets/dashboard/nls/cs/orderStatusGrid"
,"scramble/widgets/dashboard/nls/tr/orderStatusGrid"
,"scramble/widgets/dashboard/nls/pl/orderStatusGrid"
,"scramble/widgets/dashboard/nls/fi/orderStatusGrid"
,"scramble/widgets/dashboard/nls/hu/orderStatusGrid"
,"scramble/widgets/dashboard/nls/sk/orderStatusGrid"
,"scramble/widgets/dashboard/nls/nb/orderStatusGrid"
,"scramble/widgets/dashboard/nls/es/orderStatusGrid"
,"scramble/widgets/dashboard/nls/nl/orderStatusGrid"
,"scramble/widgets/dashboard/nls/pt/orderStatusGrid"
,"scramble/widgets/dashboard/nls/ru/orderStatusGrid"
,"scramble/widgets/dashboard/nls/sv/orderStatusGrid"
,"/home/semaphore/scramble4/src/scramble/widgets/dashboard/nls/orderStatusGrid.js?absMid=scramble/widgets/dashboard/nls/orderStatusGrid"
], function(loader, runner) {
   return runner(loader, "scramble/widgets/dashboard/nls/orderStatusGrid", __webpack_require__.dj.c(), false);
});